import { styleSheetDataLocalSelector, styleSheetDataSettingsSelector } from "@client/selectors/state";
import { createSelector } from "reselect";
// import { makeAssetsSettingsSelector, makeAssetsStyleSheetSelector, rootSelectorSelector } from "../selectors";

// export const makeDataSelector = () => {
//   const settingsSelector = makeAssetsSettingsSelector();
//   const styleSheetSelector = makeAssetsStyleSheetSelector();

//   const headerHeightSettingSelector = createSelector([settingsSelector, screenSelector], (settings, screen) =>
//     getInherittedSettingValue(settings, "header", "height", screen)
//   );
//   const textSelector = createSelector([styleSheetSelector, screenSelector], (styleSheet, screen) =>
//     mergeCompositeSetting<CompositeSettings.Heading>(
//       (screen) => getScreenSettings(styleSheet.settings.text.default, screen),
//       screen
//     )
//   );
//   const siteColorSelector = createSelector([styleSheetSelector, screenSelector], (styleSheet, screen) =>
//     getInherittedSettingValue(styleSheet.settings.color.primary, undefined, "color", screen)
//   );
//   const textColorSelector = createSelector([styleSheetSelector, screenSelector], (styleSheet, screen) =>
//     getInherittedSettingValue(styleSheet.settings.color.text, undefined, "color", screen)
//   );

//   return createSelector(
//     [rootSelectorSelector, textSelector, headerHeightSettingSelector, siteColorSelector, textColorSelector],
//     (rootSelector, text: CompositeSettings.Text, headerHeight, siteColor, textColor) => ({
//       rootSelector,
//       fontFamily: getFontFamilyName(text.font),
//       fontWeight: text.weight,
//       fontSize: text.size,
//       lineHeight: adjustLineHeight(text.line),
//       letterSpacing: text.letter,
//       color: textColor,
//       linkColor: text.linkColor ?? siteColor,
//       headerHeight,
//       siteColor
//     })
//   );
// };

export const styleSheetDataItemSettingsSelector = createSelector(
  [styleSheetDataSettingsSelector, (_, id: string) => id],
  (settings, id) => settings[id]
);

export const styleSheetDataItemLocalSettingsSelector = createSelector(
  [styleSheetDataLocalSelector, (_, id: string) => id],
  (local, id) => (local ? local[id] : null)
);
